import { jsx } from 'react/jsx-runtime';
import { IconBase } from '../../icon-base/index.js';

const CheckmarkAlt = (props) => (jsx(IconBase, Object.assign({}, props, { svgContent: jsx("path", { d: "M10.80009,19.80015a9,9,0,1,1,9-9A9.01054,9.01054,0,0,1,10.80009,19.80015Zm0-16.87512a7.87512,7.87512,0,1,0,7.87512,7.87512A7.88411,7.88411,0,0,0,10.80009,2.925ZM14.75,8.63964,13.95474,7.85,9.62367,12.17072,7.64331,10.20631,6.85,10.9979,9.62562,13.75Z" }), iconName: "down-caret", viewBox: "0 0 21.6 21.6" })));
CheckmarkAlt.displayName = 'VDS_Icon';

export { CheckmarkAlt as default };
